/**
 * @overview 话题管理
 * @author jzhu
 * @date 2020-9-4
 */

import React from 'react'
import { connect } from 'dva'
import { templateConfig, reduxTemplateCofig } from './config'
import { framework_tool, component_tool } from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool
let { WizBrowserExport } = component_tool

class Topic extends WizContainer {

    componentName = 'Topic'

    constructor(props) {
        super(props)
        this.state = {}
    }

    _columns = () => {
        let defaultProps = {
            cellStyle: {
                textAlign: 'center',
            },
            style: {
                alignment: { vertical: 'bottom', horizontal: 'left' },
            }
        }
        return [
            {
                headerName: '',
                width: 30,
                field: 'rowIndex',
                hidden: true,
                suppressMovable: true,
                cellStyle: {
                    textAlign: 'center',
                    padding: '5px 0',
                    color: '#595959',
                    backgroundColor: '#f0f0f0',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: '500',
                    boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
                },
            },
            {
                headerName: '话题名称',
                field: 'title',
                width: 20,
                ...defaultProps
            },
            {
                headerName: '关注数量',
                field: 'followCount',
                width: 10,
                ...defaultProps
            },
            {
                headerName: '帖子数量',
                field: 'messageCount',
                width: 10,
                ...defaultProps
            },
            {
                headerName: '有效日期',
                field: 'date',
                width: 30,
                ...defaultProps
            },
            {
                headerName: '适用范围',
                field: 'authInfo',
                width: 30,
                ...defaultProps
            },
            {
                headerName: '话题简介',
                field: 'introduce',
                width: 30,
                ...defaultProps
            },
            {
                headerName: '话题状态',
                field: 'state',
                width: 10,
                ...defaultProps
            },
            {
                headerName: '创建时间',
                field: 'createTime',
                width: 15,
                ...defaultProps
            }
        ]
    }

    _authInfo = (authInfo) => {
        let result = ''
        if (authInfo) {
            let { orgIds, positionIds, positionCategoryIds, personIds } = authInfo
            result += '组织：'
            if (orgIds && orgIds.length) {
                orgIds.forEach(org => { 
                    if (org.name) {
                        result += org.name + '、'
                    }
                 })
                 result = result.substring(0, result.length - 1)
            }
            result += ' \n'


            result += '岗位：'
            if (positionIds && positionIds.length) {
                positionIds.forEach(position => { 
                    if (position.name) {
                        result += position.name + '、'
                    }
                 })
                 result = result.substring(0, result.length - 1)
            }
            result += ' \n'


            result += '岗位分类：'
            if (positionCategoryIds && positionCategoryIds.length) {
                positionCategoryIds.forEach(positionCategory => { 
                    if (positionCategory.name) {
                        result += positionCategory.name + '、'
                    }
                 })
                 result = result.substring(0, result.length - 1)
            }
            result += ' \n'


            result += '指定人员：'
            if (personIds && personIds.length) {
                personIds.forEach(person => { 
                    if (person.fullName) {
                        result += person.fullName + '、'
                    }
                 })
                 result = result.substring(0, result.length - 1)
            }
        }
        return result
    }

    _rows = (data) => {
        let rows = []
        data && data.length && data.forEach(record => {
            let row = record
            let { start, end, state, authInfo } = record
            row.date = start + ' ~ ' + end
            row.state = state === 1 ? '有效' : '无效'
            row.authInfo = this._authInfo(authInfo)
            rows.push(row)
        })
        return rows
    }

    _export = (nextProps, nextState, key) => {
        let o = nextProps[key]
        if (o.success) {
            let columns = this._columns()
            let rows = this._rows(o.data)
            WizBrowserExport({
                title: '话题管理',
                sheetName: '话题管理',
                columns: columns.filter((_, index) => index),
                rows,
                filename: '话题管理.xlsx',
            })
            return true
        } else {
            wizNotice.error(o.msg)
            return false
        }
    }

    _render() {
        let _reduxTemplateCofig = reduxTemplateCofig({
            templateConfig: templateConfig(this),
            apiDataFormat: {
                export: this._export
            }
        })
        return <WizReduxTemplate {..._reduxTemplateCofig} />
    }
}

const mapStateToProps = (state, ownProps) => {
    return {}
}

export default connect(mapStateToProps)(Topic)
